import React from 'react';
import { GridToolbarContainerProps } from '@mui/x-data-grid-premium';

interface ToolbarProps extends GridToolbarContainerProps {
  onExport?: (type: string) => void;
  onRemove?: () => void;
  variant?: 'primary' | 'secondary';
  bottomHeight?: string;
  headerSlots?: {
    slot1?: React.ReactNode;
    slot2?: React.ReactNode;
  };
}

interface ToolbarRowProps {
  children?: React.ReactNode;
  height?: string;
  className?: string;
  borderColor?: string;
}

const ToolbarRow = ({ children, height = '100px', className = '', borderColor }: ToolbarRowProps) => (
  <div
    className={`w-full flex items-center justify-between p-4 min-h-[100px] overflow-visible ${className}`}
    style={{
      height: 'auto',
      minHeight: height,
      maxHeight: 'none',
      ...(borderColor ? { borderBottom: `1px solid ${borderColor}` } : {}),
    }}
  >
    {children}
  </div>
);

interface ToolbarBottomRowProps {
  children?: React.ReactNode;
  height?: string;
}

const ToolbarBottomRow = ({ children, height = '100px' }: ToolbarBottomRowProps) => (
  <div
    className="flex p-4 items-center self-stretch"
    style={{ height }}
  >
    {children}
  </div>
);

const TableToolbar = ({ bottomHeight = '100px', ...props }: ToolbarProps) => {
  const isPrimary = props.variant === 'primary';

  // Check if the slot1 content contains AI details by looking for specific elements
  const hasAiDetails =
    React.isValidElement(props.headerSlots?.slot1) &&
    (props.headerSlots?.slot1.props as Record<string, any>)?.aiDetails;

  // Calculate the total height based on whether AI details are present
  const totalHeight = hasAiDetails ? '240px' : '200px';
  const topRowHeight = hasAiDetails ? '140px' : '100px';

  return (
    <div
      className="flex flex-col"
      style={{
        height: 'auto',
        minHeight: totalHeight,
        maxHeight: 'none',
        borderBottom: isPrimary
          ? '1px solid #d4d4d4'
          : '1px solid #005B3899',
        background: isPrimary
          ? 'white'
          : 'var(--secondary-outlined-ActiveBg, #D6F6F1)',
      }}
    >
      <ToolbarRow
        height={topRowHeight}
        borderColor={isPrimary ? '#d4d4d4' : '#005B3899'}
      >
        {props.headerSlots?.slot1}
      </ToolbarRow>

      <ToolbarBottomRow height={bottomHeight}>
        {props.headerSlots?.slot2}
      </ToolbarBottomRow>
    </div>
  );
};

export default TableToolbar;
